<script setup lang="ts">
import type { LawAndCommentary } from '~/utils/solr/law-and-commentary'
import { useLawQuery } from '~/composables/laws/useLawQuery'
import { effectiveSuccessorLawId, resolveSuccessorLaw } from '~/utils/solr/misc-utils'

const { law } = defineProps<{ law: LawAndCommentary }>()

const successorLawId = computed(() => effectiveSuccessorLawId(law.id, law.repealedByLawId))

const { data: repealedLaw } = useLawQuery(() => successorLawId.value)

const successorLaw = computed(() => resolveSuccessorLaw(successorLawId.value, repealedLaw.value?.response?.docs[0]))
</script>

<template>
  <Callout v-if="law?.isRepealed" variant="warning" title="Opphevet" class="pb-xs">
    <p v-if="successorLaw" class="text-xs">
      Denne loven er erstattet av <LawLink v-if="successorLaw.linkable" :law="successorLaw.lawId" class="text-current">
        {{ successorLaw.title }}
      </LawLink><span v-else>{{ successorLaw.title }}</span>
    </p>
  </Callout>
</template>
